window.addEventListener('load', cartPageInit);

function cartPageInit() {
  initMoreInfoLinks();

  initQuantitySelectors();

  initRemoveFromCartLinks();

  initConfirmModal();

  checkForOrphanUpsells();

  checkForMultiConfigMismatch();

  checkForLegacyItems();

  addUpsellKeysToLegacyEditUrls();

  // Updates images for Legacy Items, modified to skip non legacy items
  Customizer.getCustomizedImages({ location: 'cart' });
}

function initRemoveFromCartLinks() {
  const removeLinks = document.querySelectorAll('a.cart__item__remove__link');
  removeLinks.forEach(removeLink => {
    removeLink.addEventListener('click', async event => {
      event.preventDefault();
      const itemElement = removeLink.closest('[data-line-item]');

      const multiConfigSiblingElements = getMultiConfigSiblingElements(
        itemElement
      );
      const isMultiConfigLine = multiConfigSiblingElements.length > 0;
      const sessionElements = [itemElement, ...multiConfigSiblingElements];

      // Any of the lines in this session (not just the one clicked) may
      // themselves have their own Add-On upsell lines attached.
      const childLineItemElements = sessionElements.flatMap(sessionElement =>
        Array.from(getChildLineItemElements(sessionElement))
      );
      const hasChildren = childLineItemElements.length > 0;

      const elementsToRemove = [...sessionElements, ...childLineItemElements];

      if (!isMultiConfigLine && !hasChildren) {
        await removeLineItemElements(elementsToRemove);
        return;
      }

      const confirmed = await showConfirmModal(
        buildRemoveConfirmMessage({ isMultiConfigLine, hasChildren })
      );

      if (confirmed) await removeLineItemElements(elementsToRemove);
    });
  });
}

function buildRemoveConfirmMessage({ isMultiConfigLine, hasChildren }) {
  const parts = [];

  if (isMultiConfigLine && hasChildren) {
    parts.push(
      'By removing this product, all the additional names you\'ve added to it, along with any matching Add-On products, will also be removed.'
    );
  } else if (isMultiConfigLine) {
    parts.push(
      'By removing this product, all the additional names you\'ve added to it will also be removed.'
    );
  } else {
    parts.push(
      'By removing this product any matching Add-On products will also be removed.'
    );
  }

  parts.push(
    'Are you sure you want to remove this product from your cart? This cannot be undone.'
  );

  const returnable = [parts.join(' ')];

  if (isMultiConfigLine) {
    returnable.push(
      'If you\'d like to remove or edit just one name, select "Edit Selection" below the product image instead.'
    );
  }

  return returnable.join('\n\n');
}

let confirmModalResolve = null;

function initConfirmModal() {
  const modal = document.getElementById('cart-confirm-modal');
  if (!modal) return;

  const cancelButton = modal.querySelector('.cart-confirm-modal__cancel');
  const confirmButton = modal.querySelector('.cart-confirm-modal__confirm');
  const overlay = modal.querySelector('[data-cart-confirm-modal-dismiss]');

  cancelButton.addEventListener('click', () => closeConfirmModal(false));
  overlay.addEventListener('click', () => closeConfirmModal(false));
  confirmButton.addEventListener('click', () => closeConfirmModal(true));

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeConfirmModal(false);
    }
  });
}

function showConfirmModal(message) {
  const modal = document.getElementById('cart-confirm-modal');

  // Fall back to the native dialog on any page that loads this script
  // without the modal markup present.
  if (!modal) return Promise.resolve(confirm(message));

  const messageElement = document.getElementById('cart-confirm-modal-message');
  const confirmButton = modal.querySelector('.cart-confirm-modal__confirm');

  messageElement.textContent = message;

  return new Promise(resolve => {
    confirmModalResolve = resolve;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    confirmButton.focus();
  });
}

function closeConfirmModal(confirmed) {
  const modal = document.getElementById('cart-confirm-modal');
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');

  if (confirmModalResolve) {
    confirmModalResolve(confirmed);
    confirmModalResolve = null;
  }
}

function initQuantitySelectors() {
  const quantityInputs = document.querySelectorAll('input.quantity--input');
  quantityInputs.forEach(input =>
    input.addEventListener('change', event => {
      event.preventDefault();
      inputChangeListener();
    })
  );

  // Belt-and-suspenders for browsers that don't fully honor `readonly` on
  // <input type="number"> (e.g. still allow spinner clicks, arrow keys, or
  // mouse-wheel scrolling to change the value). These lines represent a
  // multi-config session item and must stay locked at their current
  // quantity.
  const lockedQuantityInputs = document.querySelectorAll(
    'input.quantity--input--locked'
  );
  lockedQuantityInputs.forEach(input => {
    const resetValue = input.value;
    const revert = () => {
      if (input.value !== resetValue) input.value = resetValue;
    };

    input.addEventListener('keydown', event => {
      if (event.key !== 'Tab') event.preventDefault();
    });
    input.addEventListener('wheel', event => event.preventDefault(), {
      passive: false
    });
    input.addEventListener('input', revert);
  });
}

function initMoreInfoLinks() {
  const moreInfoLinks = document.querySelectorAll('.js-more-info-link');
  moreInfoLinks.forEach(infoLink =>
    infoLink.addEventListener('click', event => {
      event.preventDefault();
      const { target: link } = event;
      toggleMoreInfo(link);
    })
  );
}

function inputChangeListener() {
  //find all hidden inputs and remove them from the form
  const allInputs = document.querySelectorAll(
    '#cart-form input[type="number"]'
  );
  allInputs.forEach(input => !input.offsetParent && input.remove());

  //then click the hidden update form button
  const hiddenUpdateButton = document.querySelector('button[name="update"]');
  hiddenUpdateButton.click();
}

function checkForOrphanUpsells() {
  const lineItemsWithParentCode = document.querySelectorAll(
    '.js-line-item-row[data-parent-code]:not([data-parent-code=""])'
  );

  const lineItemsWithMinimumOfTwo = document.querySelectorAll(
    '[data-is-orphan="true"]'
  );

  const lineItemsToCheck = new Set([
    ...lineItemsWithParentCode,
    ...lineItemsWithMinimumOfTwo
  ]);

  let totalQuantity = 0;
  const lineItemRows = document.querySelectorAll('.js-line-item-row');

  lineItemRows.forEach(lineItemRow => {
    const quantityInput = lineItemRow.querySelector('input.quantity--input');
    totalQuantity += parseInt(quantityInput.value, 10) || 0;
  });

  // If a single upsell is the only item in the cart then don't allow
  // the customer to checkout, and show a message explaining why.
  const upsellIsOnlyCartItem =
    lineItemsToCheck.size === 1 && totalQuantity === 1;

  const checkoutButton = document.getElementById('checkout');
  const orphanedMessage = document.getElementById('orphaned');

  if (upsellIsOnlyCartItem) {
    checkoutButton.setAttribute('disabled', 'disabled');
    orphanedMessage.style.display = 'block';
    return;
  }

  checkoutButton.removeAttribute('disabled');
  orphanedMessage.style.display = 'none';
}

function checkForMultiConfigMismatch() {
  const lineItemElements = Array.from(
    document.querySelectorAll(
      '[data-line-item][data-multi-config-session-id]:not([data-multi-config-session-id=""])'
    )
  );

  const sessionsById = new Map();
  lineItemElements.forEach(lineItemElement => {
    const sessionId = lineItemElement.getAttribute(
      'data-multi-config-session-id'
    );
    if (!sessionsById.has(sessionId)) sessionsById.set(sessionId, []);
    sessionsById.get(sessionId).push(lineItemElement);
  });

  const mismatchedSessions = [];
  sessionsById.forEach(sessionLineItemElements => {
    const expectedCount = parseInt(
      sessionLineItemElements[0].getAttribute('data-multi-config-count'),
      10
    );

    // Each line in a multi-config session is priced as a single unit (the
    // first is free, the rest discounted), so the number of lines must
    // match the expected tier count AND every line's quantity must be
    // exactly 1 -- otherwise someone has bumped a line's quantity (e.g. via
    // /cart/change.js directly) to get extra free/discounted units without
    // tripping the line-count check below.
    const totalQuantity = sessionLineItemElements.reduce(
      (sum, lineItemElement) => {
        const quantityInput = lineItemElement.querySelector(
          'input.quantity--input'
        );
        return sum + (parseInt(quantityInput.value, 10) || 0);
      },
      0
    );

    if (
      sessionLineItemElements.length !== expectedCount ||
      totalQuantity !== expectedCount
    ) {
      mismatchedSessions.push(sessionLineItemElements);
    }
  });

  if (mismatchedSessions.length === 0) return;

  const checkoutButton = document.getElementById('checkout');
  checkoutButton.setAttribute('disabled', 'disabled');

  const banner = document.getElementById('multi-config-mismatch');
  const linksContainer = document.getElementById(
    'multi-config-mismatch-links'
  );
  linksContainer.innerHTML = '';

  mismatchedSessions.forEach(sessionLineItemElements => {
    sessionLineItemElements.forEach(lineItemElement =>
      lineItemElement.classList.add('multi-config-mismatch')
    );

    const editSelectionLink = sessionLineItemElements
      .map(lineItemElement =>
        lineItemElement.querySelector('.edit-selection-link')
      )
      .find(link => link);
    if (!editSelectionLink) return;

    const reviewLinkWrapper = document.createElement('div');
    const reviewLink = document.createElement('a');
    reviewLink.href = editSelectionLink.getAttribute('href');
    reviewLink.textContent = 'Review Pricing';
    reviewLinkWrapper.appendChild(reviewLink);
    linksContainer.appendChild(reviewLinkWrapper);
  });

  banner.style.display = 'block';
}

function checkForLegacyItems() {
  const legacyItems = document.querySelectorAll(
    '.js-line-item-row[data-order-system="LEGACY"]'
  );

  if (legacyItems.length) {
    const checkout = document.getElementById('checkout');
    checkout.setAttribute('disabled', 'disabled');
    const legacyMessage = document.getElementById('legacy-items-in-cart');
    legacyMessage.style.display = 'block';
  }
}

function getChildLineItemElements(itemElement) {
  const legacyProductCode = itemElement.getAttribute('data-product-code');
  return legacyProductCode
    ? document.querySelectorAll(
        `.js-line-item-row[data-parent-code="${legacyProductCode}"]`
      )
    : [];
}

function getChildLineItemKeys(itemElement) {
  const childLineItemElements = getChildLineItemElements(itemElement);
  return Array.from(childLineItemElements).map(childLineItemElement =>
    childLineItemElement.getAttribute('data-line-item-key')
  );
}

function getMultiConfigSiblingElements(itemElement) {
  const sessionId = itemElement.getAttribute('data-multi-config-session-id');
  if (!sessionId) return [];

  return Array.from(
    document.querySelectorAll(
      `[data-line-item][data-multi-config-session-id="${sessionId}"]`
    )
  ).filter(siblingElement => siblingElement !== itemElement);
}

async function removeLineItemElements(elements) {
  const lineItemKeys = elements.map(element =>
    element.getAttribute('data-line-item-key')
  );

  const updates = {};
  lineItemKeys.forEach(lineItemKey => (updates[lineItemKey] = 0));

  await updateCartQuantities(updates);
  window.location.reload();
}

function toggleMoreInfo(linkElement) {
  const id = linkElement.getAttribute('data-id');
  const infoSectionElement = document.querySelector(
    `.js-more-info-text[data-id="${id}"]`
  );

  const isOpen = infoSectionElement.classList.contains('open');
  if (isOpen) {
    infoSectionElement.classList.remove('open');
    linkElement.innerHTML = '+ more info';
    return;
  }

  infoSectionElement.classList.add('open');
  linkElement.innerHTML = '- less info';
}

function updateCartQuantities(updates) {
  return (updatedCartQuantities = fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  }));
}

function centsToDollars(cents) {
  return (cents / 100).toFixed(2);
}

function getParentLineItemElements() {
  const allLineItemElements = document.querySelectorAll('.js-line-item-row');
  const nonUpsellLineItems = Array.from(allLineItemElements).filter(item => {
    const parentCode = item.getAttribute('data-parent-code');
    return !parentCode;
  });
  return nonUpsellLineItems;
}

function getAllParentLegacyLineItemElements() {
  const lineItemElements = getParentLineItemElements();
  const legacyLineItemElements = lineItemElements.filter(item => {
    const orderSystem = item.getAttribute('data-order-system');
    return orderSystem === 'LEGACY';
  });
  return legacyLineItemElements;
}

function addUpsellKeysToLegacyEditUrls() {
  const baseUrl = window.location.origin;
  const legacyLineItemElements = getAllParentLegacyLineItemElements();
  legacyLineItemElements.forEach(legacyLineItemElement => {
    const editLinks = legacyLineItemElement.querySelectorAll(
      '.edit-selection-link'
    );

    const upsellKeys = getChildLineItemKeys(legacyLineItemElement);

    editLinks.forEach(editLink => {
      const href = editLink.getAttribute('href');
      const url = new URL(href, baseUrl);
      upsellKeys.forEach(key => url.searchParams.append('upsell', key));
      editLink.setAttribute('href', url.toString());
    });
  });
}
